<ui-grid-row *ngIf="!hidden" class="p-4 bg-dark text-white no-print align-items-center" style="position: relative; z-index: 10000; border-top: 1px solid #111a22;" weight-0>
	<div class="flex-weight-1">
		Our website uses cookies to give you the best and most relevant experience. By clicking on accept, you give your consent to the use of cookies as per our <a class="text-white" href="https://wequote.cloud/privacy-policy" target="_blank">privacy policy</a>.
	</div>
	<div class="ml-4">
		<button type="button" class="btn btn-light" (click)="accept()">Accept</button>
	</div>
</ui-grid-row>
